import { render, staticRenderFns } from "./CollectionCover.vue?vue&type=template&id=9ca498c4&scoped=true"
import script from "./CollectionCover.vue?vue&type=script&lang=js"
export * from "./CollectionCover.vue?vue&type=script&lang=js"
import style0 from "./CollectionCover.vue?vue&type=style&index=0&id=9ca498c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca498c4",
  null
  
)

export default component.exports